export default "__VITE_ASSET__63ON3pyM__"